import { isClub, JsEnv } from '../../../core/models/js_env';
import { AddRecommendationItem } from '../models/add_recommendation_item';
import { AddRecommendationItemJsEnv, RecommendationItemFoldersAPI } from '../models/add_recommendation_item_js_env'
import { TypedEvent } from '../../../core/typed_event';
import { ListRecommendationItemRepository } from '../../../core/repositories/list_recommendation_item_repository';
import { Env } from '../../../core/env';
import { MessageConverter } from '../../../core/util/message_converter';
import { AnalyticsItems } from '../../../core/models/analytics/analytics_items';
import { AnalyticsItem } from '../../../core/models/analytics/analytics_item';
import { SupplierId } from '../../../core/models/supplier_id';
import { AdobeAnalyticsData } from '../../../core/models/analytics/adobe_analytics_data';
import { AddRecommendationItemFinishAnalytics } from '../../../core/actions/analytics/add_recommendation_item_finish_analytics';
import { AddRecommendationVariationAnalytics } from '../../../core/actions/analytics/add_recommendation_variation_analytics';
import { AddRecommendationItemAnalytics } from '../../../core/actions/analytics/add_recommendation_item_analytics';

const REGISTER_ERROR_STATUS = 400;
const GET_FOLDER_ERROR_MESSAGE =
  '推奨品フォルダ情報の取得処理に失敗しました。もう一度お試しください。';

export class AddRecommendationItemAction {
    static readonly UPDATE_EVENT = new TypedEvent<AddRecommendationItemJsEnv>();
    static readonly ADD_RECOMMENDATION_ITEM_EVENT = new TypedEvent<AnalyticsItems>();
    static readonly ADD_RECOMMENDATION_ITEM_FINISH_EVENT = new TypedEvent<AnalyticsItems>();
    static readonly ADD_RECOMMENDATION_VARIATION_EVENT = new TypedEvent<AdobeAnalyticsData>();
    static readonly ADD_RECOMMENDATION_VARIATION_FINISH_EVENT = new TypedEvent<AdobeAnalyticsData>();
    private static state: AddRecommendationItem;

    static init(env: JsEnv, containerClass: any) {
        if (isClub(Env.SITE_TYPE)) {
          // 推奨品はCLUB対象外
          return;
        }
        this.state = new AddRecommendationItem(env.PAGE);
        this.state.setIsLoadedCompanyFolders(true);
        this.state.setIsLoadedDepartmentFolders(true);
        this.state.setIsWarningHidden(true);
        this.state.setIsCreateFolderWarningHidden(true);
        this.state.resetMarginCount();
        /// AdobeAnalytics　推奨品に登録・登録完了
        new AddRecommendationItemAnalytics(); // NOSONAR
        new AddRecommendationItemFinishAnalytics(); // NOSONAR
        new AddRecommendationVariationAnalytics(); // NOSONAR
        return new containerClass(this.state.getModel());
    }

    static isFolderNameEmpty() {
      return this.state.isFolderNameEmpty();
    }
    static checkTextMargin() {
      const textElm = this.getFolderNameInput();
      this.state.setMarginCount(textElm.value.length);
      this.UPDATE_EVENT.trigger(this.state.getModel());
    }
    static resetUI() {
      this.state.setRecommendationItemFoldersApiResult(RecommendationItemFoldersAPI.OK);
      this.state.setCompanyRecommendationFolders([]);
      this.state.setDepartmentRecommendationFolders([]);
      this.state.setWarningMessage('');
      this.state.setIsCreateFolderWarningHidden(true);
      this.state.resetMarginCount();
      this.getFolderNameInput().value = ''
      this.UPDATE_EVENT.trigger(this.state.getModel());
    }

    static async registerWithSelectedFolder() {
      this.state.setWarningMessage('');

      const radioSelected = document.querySelector('input[name="selected-folder"]:checked') as HTMLInputElement;
      const folderId = radioSelected.dataset.folderId as string;
      const folderName = radioSelected.dataset.folderName as string;
      // R1はフォルダータイプ不要、廃棄と正式決めたらFolderTypeを完全に削除
      // const folderType =  radioSelected.dataset.folderType as FolderType;
      this.state.setRecommendationFolderName(folderName);

      new ListRecommendationItemRepository().upsertRecommendationItem(
        this.state.getSupplierId(),
        this.state.getCatalogItemCode(),
        this.state.getVariationCode(),
        folderId,
        folderName,
      ).then(() => {
        const target = <HTMLElement>document.getElementById('add_recommendation_item_finish');
        if (this.state.getVariationCode() !== '' && window.analyticsData.sku === undefined) {
          this.ADD_RECOMMENDATION_VARIATION_FINISH_EVENT.trigger({ target })
        } else {
          this.addRecommendationItemFinishAnalytics(target)
        }
        let openElm: HTMLElement = <HTMLElement>document.getElementById("openFinishModal");
        let closeElm: HTMLElement = <HTMLElement>document.getElementById("registration-modal-close");
        openElm.click();
        closeElm.click();
        // 再度フォルダ状態を更新する
        AddRecommendationItemAction.getRecommendationFolders()
      }).catch((e: Error) => {
        this.state.setWarningMessage(e.message);
        this.UPDATE_EVENT.trigger(this.state.getModel());
      });
    }

    static async createFolderRequest() {
      const listRecommendationItemRepository = new ListRecommendationItemRepository();
      listRecommendationItemRepository.createFolder(
        this.state.getSupplierId(),
        this.state.getCatalogItemCode(),
        this.state.getVariationCode(),
      ).then(() => {
        this.state.setIsCreateFolderWarningHidden(true);
        this.state.setRecommendationFolderName(this.getFolderNameInput().value);
        let openElm: HTMLElement = <HTMLElement>document.getElementById("openFinishModal");
        let closeElm: HTMLElement = <HTMLElement>document.getElementById("create-folder-modal-close");
        openElm.click();
        closeElm.click();
        // 再度フォルダ状態を更新する
        AddRecommendationItemAction.getRecommendationFolders()
      }).catch((e: Error) => {
        this.state.setIsCreateFolderWarningHidden(false);
        this.state.setWarningMessage(e.message);
        this.UPDATE_EVENT.trigger(this.state.getModel());
      });
    }

  private static getFolderNameInput() {
    return document.getElementById("foldername04") as HTMLInputElement;
  }

  static getRecommendationFolders() {
    this.state.setCompanyRecommendationFolders([]);
    this.state.setDepartmentRecommendationFolders([]);
    this.state.setWarningMessage('');

    new ListRecommendationItemRepository().getRecommendationFolders().then((result) => {
        this.state.setRecommendationItemFoldersApiResult(RecommendationItemFoldersAPI.OK);
        this.state.setCompanyRecommendationFolders(result.companyFolders);
        this.state.setDepartmentRecommendationFolders(result.departmentFolders);
        const count = result.departmentFolders.length + result.companyFolders.length;
        if (count === 0) {
          this.state.setRecommendationItemFoldersApiResult(RecommendationItemFoldersAPI.NO_FOLDERS);
        }
        this.UPDATE_EVENT.trigger(this.state.getModel());
      })
      .catch((error) => {
        if (error.response?.status === REGISTER_ERROR_STATUS) {
          const errorCode = error.response.data.errors[0].code;
          /// 取得結果なしの場合
          if (errorCode === '1') {
            this.state.setRecommendationItemFoldersApiResult(RecommendationItemFoldersAPI.NO_FOLDERS);
            const errorMessage = MessageConverter.errorMessageConverter(error.response.data.errors[0].message);
            this.state.setWarningMessage(errorMessage);
            this.UPDATE_EVENT.trigger(this.state.getModel());
            return;
          }
          this.state.setRecommendationItemFoldersApiResult(RecommendationItemFoldersAPI.ERROR);
          const errorMessage = MessageConverter.errorMessageConverter(error.response.data.errors[0].message);
          this.state.setWarningMessage(errorMessage);
        } else {
          this.state.setWarningMessage(GET_FOLDER_ERROR_MESSAGE);
        }
        this.UPDATE_EVENT.trigger(this.state.getModel());
      });
  }

    static openModal(e: Event) {
      // 再度フォルダ状態を更新する
      AddRecommendationItemAction.getRecommendationFolders();
      // Reset UI error message
      AddRecommendationItemAction.resetUI()
      // Set Modal Data
      const input = e.target as HTMLInputElement;
      const dataset = (input.parentElement as HTMLDivElement).dataset;
      this.state.setSupplierId(dataset.supplierId || ''); // data-supplier-id
      this.state.setCatalogItemCode(dataset.catalogItemCode || ''); // data-catalog-item-code
      this.state.setVariationCode(dataset.variationCode || ''); // data-variation-code
      const target = <HTMLElement>document.getElementById('add_recommendation_item');
      if(this.state.getVariationCode() !== '' && window.analyticsData.sku === undefined){
        this.ADD_RECOMMENDATION_VARIATION_EVENT.trigger({ target });
      } else {
        this.addRecommendationItemAnalytics( target );
      }
    }

    /// 推奨品に登録する（モーダル表示）のAdobe Analyticsトリガーを設定
  static addRecommendationItemAnalytics(target: HTMLElement) {
    const item: AnalyticsItem = this.getRecommendationItemData();
    this.ADD_RECOMMENDATION_ITEM_EVENT.trigger({
      target: target,
      analyticsData: {
        items: [item]
      },
    });
  }

    /// 推奨品に登録完了のAdobe Analyticsトリガーを設定
  static addRecommendationItemFinishAnalytics(target: HTMLElement) {
    const item: AnalyticsItem = this.getRecommendationItemData();
    this.ADD_RECOMMENDATION_ITEM_FINISH_EVENT.trigger({
      target: target,
      analyticsData: {
        items: [item]
      },
    });
  }

  /// 推奨品に登録登録データ作成
  private static getRecommendationItemData() {
    let item: AnalyticsItem = new AnalyticsItem();
    item._supplierId = new SupplierId(this.state.getModel().supplierId);
    item._catalogItemCode = this.state.getModel().catalogItemCode;

    return item;
  }
}
